import React, { useEffect, useMemo, useState } from "react";

const UNICORN_URL = "/unicorn-transparent.png";
const SPARKLE_COLORS = ["#FFD166", "#FF6FB5", "#7EE8D3", "#C9A6FF", "#FFFFFF"];

function buildSparkles(count) {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    top: Math.random() * 70 + 8,
    left: Math.random() * 30 + 65,
    sx: `${24 + Math.random() * 70}px`,
    sy: `${(Math.random() - 0.5) * 90}px`,
    size: 4 + Math.random() * 7,
    color: SPARKLE_COLORS[i % SPARKLE_COLORS.length],
    delay: Math.random() * 1.4,
    duration: 0.8 + Math.random() * 0.8,
  }));
}

/** Kleine Feier-Animation, die einmal pro Kunde (session-weit) über den Bildschirm fliegt,
 * sobald ein Kunde als abgeschlossen erkannt wird — mit Glitzer-Partikeln, die sich hinter
 * dem (transparenten) Einhorn verteilen. */
export default function UnicornCelebration({ clientId }) {
  const [show, setShow] = useState(false);
  const sparkles = useMemo(() => buildSparkles(16), []);

  useEffect(() => {
    const key = `unicorn_shown_${clientId}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    setShow(true);
    const t = setTimeout(() => setShow(false), 3700);
    return () => clearTimeout(t);
  }, [clientId]);

  if (!show) return null;
  return (
    <div className="unicorn-flyby" data-testid="unicorn-celebration">
      {sparkles.map((s) => (
        <span
          key={s.id}
          className="unicorn-sparkle"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            background: s.color,
            color: s.color,
            "--sx": s.sx,
            "--sy": s.sy,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
      <img src={UNICORN_URL} alt="" className="unicorn-flyby-img" />
    </div>
  );
}
